<template>
  <div class="vl-comp-list">
    <!--左侧详情-->
    <div class="cl-left">
      <div class="lt-img">
        <img :src="appInfo.appLogo" alt="">
      </div>
      <div class="lt-info">
        <h3>{{appInfo.appName}}</h3>
        <div class="ti-title">
          <span>{{appInfo.appTypeName}}</span>
          <span class="ti-middle">|</span>
          <span>{{appInfo.appTerminalTypeName}}</span>
        </div>
        <p>已接入组件数: {{appInfo.moduleNum}}</p>
      </div>
    </div>
    <!--右侧列表-->
    <div class="cl-right">
      <div class="lr-title">
        <span>组件管理</span>
        <div class="lr-btn">
          <el-button type="primary" @click="addComp(1)">组件接入登记</el-button>
          <el-button type="primary" @click="goToCompStandard">组件接入规范</el-button>
        </div>
      </div>
      <div class="lr-table">
        <el-table
          :data="compList"
          border
          stripe
          style="width: 100%">
          <el-table-column
            prop="moduleName"
            label="组件名称"
            width="140">
          </el-table-column>
          <el-table-column
            prop="moduleId"
            label="组件ID"
            width="180">
          </el-table-column>
          <el-table-column
            prop="terminalType"
            width="160"
            label="终端类型">
            <template slot-scope="scope">
              <span>{{appInfo.appTerminalTypeName}}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="100"
            show-overflow-tooltip
            prop="moduleAccountTypeName"
            label="适用对象">
          </el-table-column>
          <el-table-column
            prop="status"
            width="100"
            label="接入状态">
            <template slot-scope="scope">
              <span>{{interfaceStatus[scope.row.status]}}</span>
            </template>
          </el-table-column>
          <el-table-column
            min-width="200"
            label="操作">
            <template slot-scope="scope">
              <div class="rt-ops">
                <span
                  v-if="scope.row.moduleOperationDTO.update == 1"
                  @click="editComp(scope.row, 2)"
                >编辑</span>
                <span
                  v-if="scope.row.moduleOperationDTO.details == 1"
                  @click="showCompDetail(scope.row)"
                >查看详情</span>
                <span
                  v-if="scope.row.moduleOperationDTO.offLine == 1"
                  @click="offLineApply(scope.row)"
                >下线</span>
                <span
                  v-if="scope.row.moduleOperationDTO.onLine == 1"
                  @click="onLineApply(scope.row)"
                >上线申请</span>
                <span
                  v-if="scope.row.moduleOperationDTO.develop == 1 && scope.row.status == '2'"
                  @click="compDevelop(scope.row)"
                >组件更新</span>
                <span
                  v-if="scope.row.moduleOperationDTO.develop == 1 && scope.row.status != '2'"
                  @click="compDevelop(scope.row)"
                >组件开发</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!--组件接入弹窗-->
    <el-dialog
      :title="compOps === 3 ? '组件详情' : '组件接入登记'"
      :visible.sync="compAddDialog"
      :close-on-click-modal="false"
      width="800px"
      :before-close="handleClose">
      <div class="comp-dialog-main">
        <!--新增编辑-->
        <div class="dm-add" v-if="compOps === 1 || compOps === 2">
          <el-form :model="compForm" :rules="compRules" ref="compForm" label-width="100px">
            <el-form-item label="组件名称：" prop="moduleName">
              <el-input style="width: 300px;" placeholder="请输入不超过10个字符" maxlength="10" v-model="compForm.moduleName"></el-input>
            </el-form-item>
            <el-form-item label="适用终端：" prop="terminalType">
              <el-radio :label="1" v-model="compForm.terminalType">{{appInfo.appTerminalTypeName}}</el-radio>
            </el-form-item>
            <el-form-item label="适用对象：" prop="accountType">
              <el-checkbox-group v-model="compForm.accountType" :disabled="compForm.updateDialog">
                <el-checkbox
                  name="type"
                  v-for="(item, index) in accountTypeList"
                  :label="item.code"
                  :key="'comp-account-' + index">
                  {{item.name}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="适用学段：" prop="periodType">
              <el-checkbox-group v-model="compForm.periodType" :disabled="compForm.updateDialog">
                <el-checkbox
                  name="type"
                  v-for="(item, index) in periodTypeList"
                  :label="item.code"
                  :key="'comp-period-' + index">
                  {{item.name}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="组件图标：" prop="moduleLogo">
              <el-upload
                ref="uploadAppLogoImage"
                class="avatar-uploader"
                :key="'uploadAppLogoImage'"
                :action="uploadImageUrl"
                :show-file-list="false"
                :with-credentials="true"
                :before-upload="beforeAppLogoUpload"
                :headers="headers"
                :on-success="uploadAppLogoImage">
                <img v-if="compForm.moduleLogo" :src="compForm.moduleLogo" class="avatar">
                <i class="el-icon-plus avatar-uploader-icon" v-else></i>
              </el-upload>
            </el-form-item>
            <el-form-item
              v-if="(compOps === 1 && hasVisitEdit) || (compOps === 2 && moduleVisit)"
              label="跳转链接："
              prop="moduleVisitUrl">
              <el-input
                v-model="compForm.moduleVisitUrl"
                placeholder="https://开头，不超过500字。"
              ></el-input>
              <p style="color: #999999">组件"更多内容"的链接，如果不填写，则跳转到所属应用的访问地址。</p>
            </el-form-item>
          </el-form>
        </div>
        <!--查看-->
        <div class="dm-detail" v-else>
          <div class="dm-line">
            <span>组件名称：</span>
            <div class="message">{{compDetail.moduleName}}</div>
          </div>
          <div class="dm-line">
            <span>组件ID：</span>
            <div class="message">{{compDetail.moduleId}}</div>
          </div>
          <div class="dm-line">
            <span>上线日期：</span>
            <div class="message">{{compDetail.updateDate}}</div>
          </div>
          <div class="dm-line">
            <span>适用终端：</span>
            <div class="message">{{appInfo.appTerminalTypeName}}</div>
          </div>
          <div class="dm-line">
            <span>适用对象：</span>
            <div class="message">{{compDetail.accountTypeName}}</div>
          </div>
          <div class="dm-line">
            <span>适用学段：</span>
            <div class="message">{{compDetail.periodTypeName}}</div>
          </div>
          <div class="dm-line">
            <span>组件图标：</span>
            <img :src="compDetail.moduleLogo" alt="" style="height:120px;">
          </div>
          
        <span slot="footer" class="comp-add-footer">
          <el-button
          @click="detailClose('compForm')"
        >关 闭</el-button>
        </span>
        </div>
      </div>
      <span slot="footer" class="comp-add-footer">
        <el-button
          @click="resetForm('compForm')"
          v-show="compOps === 1 || compOps === 2"
        >取 消</el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="submitForm('compForm')"
          v-show="compOps === 1 || compOps === 2"
        >提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import {
    PersonalGetModuleInfoListByAppId,
    PersonalGetAppBaseInfoByAppId,
    PersonalPostUpdateModuleInfo,
    PersonalGetModuleBaseInfoByModuleId,
    PersonalGetModuleManageOnLine,
    PersonalGetModuleManageOffLine,
    PersonalGetModuleInfoById
  } from '@/views/index/api/personalCenter/api.personalCenter.js';
  import {
    CommonGetIndexDocInfo,
  } from "@/views/index/api/api.common.js";
  import { ajaxCtx } from "@/config/config.js";
  export default {
    data() {
      return {
        uploadImageUrl: ajaxCtx.base + 'file/upload',
        headers: {
          'Access-Token': this.$store.state.loginUser && this.$store.state.loginUser.accessToken
        },
        hasVisitEdit: false, // 新增时是否可以设置应用访问地址
        moduleVisit: false, // 编辑时是否可以设置应用访问地址
        appId: null,
        appInfo: {
          appName: '学习中心',
          appStatus: '',
        }, // 应用组件信息
        terminalTypeName: "WEB",
        basicId: null,
        compList: [], //组件列表
        clientType: {
          '1': 'WEB',
          '2': 'APP',
        }, // 终端类别
        interfaceStatus: {
          '1': '接入中',
          '2': '已上线',
          '3': '已下线',
        }, // 接入状态
        compAddDialog: false, // 组件接入，编辑，查看弹窗
        compOps: 1, // 1新增，2编辑，3查看
        compForm: {
          terminalType: 1,
          moduleName: '',
          accountType: [],
          periodType: [],
          moduleLogo: '',
          moduleVisitUrl: '',
          moduleId: null,
          updateDialog: false,
        }, // 表单
        compDetail: {},
        compRules: {
          terminalType: [
            { required: true, message: '', trigger: 'blur' },
          ],
          moduleName: [
            { required: true, message: '请输入组件名', trigger: 'change' }
          ],
          accountType: [
            { type: 'array', required: true, message: '请至少选择一个适用对象', trigger: 'change' }
          ],
          moduleLogo: [
            { required: true, message: '请上传组件图标', trigger: 'change' }
          ],
        },
        accountTypeList: [], // 身份列表
        periodTypeList: [], // 适用学段列表
        submitLoading: false,
      }
    },
    mounted() {
      this.appId = this.$route.query.appId;
      this.getModuleInfo();
      this.getAppBaseInfo();
      this.getIndexDocInfo();
    },
    methods: {
      /**
       * 获取不同的docId
       * */
      getIndexDocInfo() {
        CommonGetIndexDocInfo().then(
          res => {
            if (res && res.result) {
              this.basicId = res.result.baseDocId;
            }
          },
          (error) => {
            console.log(error);
          }
        );
      },
      /**
       * 获取应用组件信息
       * */
      getModuleInfo() {
        let params = {
          appId: this.appId
        }
        PersonalGetModuleInfoListByAppId(params).then(res => {
          if (res && res.result) {
            this.appInfo = res.result;
            this.compList = res.result.moduleInfoList
          }
        })
      },
      /**
       * 获取应用基本信息
       * */
      getAppBaseInfo() {
        let params = {
          appId: this.appId
        }
        PersonalGetAppBaseInfoByAppId(params).then(res => {
          if (res && res.result) {
            this.accountTypeList = res.result.accountTypeInfoList;
            this.periodTypeList = res.result.periodTypeInfoList;
            this.hasVisitEdit = res.result.visitType === '1';
            if(res.result.terminalType == '2'){
              this.terminalTypeName = "APP";
            }
          }
        })
      },
      /**
       * 编辑查看组件
       * */
      editComp(data, type) {
        this.$_showLoading({target: '.vl-comp-list', text: '正在获取详情'})
        PersonalGetModuleBaseInfoByModuleId({moduleId: data.moduleId}).then(res => {
          if (res && res.result) {
            this.compForm.moduleId = res.result.moduleId;
            this.compForm.moduleName = res.result.moduleName;
            this.compForm.moduleLogo = res.result.moduleLogo;
            this.compForm.moduleVisitUrl = res.result.moduleVisitUrl;
            this.moduleVisit = res.result.visitType === '1';
            let that = this;
            that.compForm.accountType = [];
            that.compForm.periodType = [];
            res.result.accountTypeInfoList.forEach(function (data) {
              if(data.selected == "1"){
                that.compForm.accountType.push(data.code);
              }
            });
            res.result.periodTypeInfoList.forEach(function (data) {
              if(data.selected == "1"){
                that.compForm.periodType.push(data.code);
              }
            });
            that.compForm.updateDialog = true;
            this.addComp(type);
          }
          this.$_hideLoading();
        })
      },

      /**
       * 新增编辑查看组件弹窗
       * */
      addComp(type) {
        if (type === 1) {
          this.compForm.moduleId = null;
        }
        this.compOps = type;
        this.compAddDialog = true;
      },
      /**
       * 点击X关闭弹窗前回调
       * */
      handleClose() {
        this.compAddDialog = false;
        if (this.compOps !== 3) {
          this.$refs['compForm'].resetFields();
        }
        this.dialogClose();

      },
      /**
       * 关闭组件查看详情
       */
      detailClose() {
        this.compAddDialog = false;
        this.dialogClose();
      },
      /**
       * 关闭前数据初始化
      */
      dialogClose() {
        this.compForm.moduleName = '';
        this.compForm.accountType = [];
        this.compForm.periodType = [];
        this.compForm.moduleLogo = '';
        this.compForm.moduleId = null;
        this.compForm.updateDialog = false;
      },
      /**
       * 上传图标校验
       * */
      beforeAppLogoUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
        const isLt1M = file.size / 1024 / 1024 < 1;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt1M) {
          this.$message.error('上传头像图片大小不能超过 1MB!');
        }
        return isJPG && isLt1M;
      },
      /**
       * 上傳成功
       * */
      uploadAppLogoImage(res) {
        if (res && res.result) {
          this.compForm.moduleLogo = res.result.accessUrl;
          this.$refs['compForm'].validateField('moduleLogo');
        }
      },
      /**
       * 提交表单
       * */
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.submitLoading = true;
            let params = {
              moduleId: this.compForm.moduleId,
              moduleName: this.compForm.moduleName,
              terminalType: this.compForm.terminalType,
              accountType: this.compForm.accountType.join(','),
              periodType: this.compForm.periodType.join(','),
              moduleLogo: this.compForm.moduleLogo,
              moduleVisitUrl: this.compForm.moduleVisitUrl,
              appId: this.appId
            }
            if (this.compOps === 2 && this.compForm.appId) {
              params.moduleId = this.compForm.moduleId;
            }
            PersonalPostUpdateModuleInfo(params).then(res => {
              if (res) {
                this.handleClose();
                this.getModuleInfo();
              }
              this.submitLoading = false;
              this.dialogClose();
            })
          }
        })
      },
      /**
       * 重置表单
       * */
      resetForm(formName) {
        this.compAddDialog = false;
        this.compForm.updateDialog = false;
        this.$refs[formName].resetFields();
        this.dialogClose();
      },
      /**
       * 查看组件规范
       * */
      goToCompStandard() {
        this.$router.push({name: 'basicDoc', query: { docId: this.basicId } })
      },
      /**
       * 组件开发
       * */
      compDevelop(data) {
        let routeUrl =  this.$router.resolve({
          name: 'compDevelop',
          query: { moduleId: data.moduleId }
        });
        let tarUrl = routeUrl.href.slice(routeUrl.href.indexOf('#'));
        window.open(tarUrl, '_blank');
      },
      /**
       * 上线申请
       * */
      onLineApply(data) {
        PersonalGetModuleManageOnLine({moduleId: data.moduleId}).then(res => {
          if (res) {
            this.getModuleInfo();
            if(this.appInfo.appStatus == "app_status_8"){
              this.$MyMessage('上线成功', 'success');
            }else{
              this.$MyMessage('应用组件上线申请提交成功，待应用上线后，组件可在用户个人门户展示。', 'success');
            }
          }
        })
      },
      /**
       * 下线
       * */
      offLineApply(data) {
        PersonalGetModuleManageOffLine({moduleId: data.moduleId}).then(res => {
          if (res) {
            this.$MyMessage('已下线', 'success');
            this.getModuleInfo();
          }
        })
      },
      /**
       * 查看详情
       * */
      showCompDetail(data) {
        this.$_showLoading({target: '.vl-comp-list', text: '正在获取详情'})
        PersonalGetModuleInfoById({moduleId: data.moduleId}).then(res => {
          if (res && res.result) {
            this.compDetail = res.result;
            this.addComp(3);
          }
          this.$_hideLoading();
        })
      },

    },
  }
</script>
<style lang="scss" scoped>
  .vl-comp-list {
    display: flex;
    min-height: 857px;
    .cl-left {
      width: 250px;
      border-right: 1px solid #EBEEF5;
      padding-top: 24px;
      background: url(../../../../../assets/img/menuBg.png) no-repeat;
      .lt-img {
        display: flex;
        justify-content: center;
        img {
          width: 86px;
          height: 86px;
        }
      }
      .lt-info {
        h3 {
          @include setColor('color', 'font_5');
          font-size: 18px;
          font-weight: 600;
          text-align: center;
          margin-top: 14px;
        }
        .ti-title {
          @include setColor('color', 'font_1');
          font-size: 16px;
          display: flex;
          justify-content: center;
          line-height: 24px;
          .ti-middle {
            margin: 0 5px;
          }
        }
        > p {
          margin-top: 20px;
          text-align: center;
          @include setColor('color', 'font_4');
        }
      }
    }
    .cl-right {
      width: calc(100% - 250px);
      padding: 30px;
      .lr-title {
        width: 100%;
        height: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
        > span {
          height: 25px;
          text-indent: 10px;
          border-left: 4px solid;
          @include setColor('border-color', 'chunk_1');
          font-size: 18px;
        }
      }
      .rt-ops {
        span {
          padding: 0 5px;
          border-left: 1px solid #c2bdbd;
          cursor: pointer;
          @include setColor('color', 'font_2');
          &:first-child {
            border-left: none;
          }
        }
      }
    }
  }
</style>
<style lang="scss">
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .comp-dialog-main {
    padding: 0 50px;
    .dm-detail {
      .dm-line {
        display: flex;
        margin-bottom: 20px;
        > span {
          width: 220px;
          text-align: right;
          margin-right: 20px;
        }
      }
    }
  }
  .comp-add-footer {
    display: block;
    text-align: center;
  }
</style>